// Package Imports
import { Form, Segmented } from 'antd';
import { SegmentInputProps } from 'components/segment/type';

const SegmentInput = ({
  name,
  optionList,
  initialValue,
  disabled,
  className,
  onChange,
  label,
}: SegmentInputProps) => (
  <>
    {label ? (
      <label className="floating-label">
        {label} <span className="a8-error">*</span>
      </label>
    ) : null}
    <Form.Item
      className="mb-0"
      name={typeof name === 'string' ? [name] : name}
      initialValue={initialValue}
    >
      <Segmented
        size="large"
        className={className}
        options={optionList}
        disabled={disabled}
        onChange={typeof onChange === 'function' ? onChange : undefined}
      />
    </Form.Item>
  </>
);

export default SegmentInput;
